export default __webpack_public_path__ + "static/media/clarification-pertaining-to-the-postal-ballot.d173768c.pdf";